// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1Uswb","card":"Cards_card__2fKbT","infected":"Cards_infected__2dlKP","recovered":"Cards_recovered__3giod","deaths":"Cards_deaths__2jRqQ"};